// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"3f3c245b","94":"eed3bf58","191":"fba460fa","344":"3a6f4ef5","451":"ae809a08","469":"c253a57b","513":"abbf70f2","782":"3fd5ba22"}[chunkId] + ".chunk.js";
};